import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../configHelper';

@Injectable({
  providedIn: 'root'
})
export class RequisitionIntakeDataService {

  constructor(private httpClient: HttpClient, private configService: ConfigService) {
  }

  public getForIntake(accession, packageId: number) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/RequisitionIntake/GetForIntake?accession=${accession}&packageId=${packageId}`;
    return this.httpClient.get(url);
  }

  public intervennGetForIntake(accession) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/RequisitionIntake/GetForIntakeInterVenn?accession=${accession}`;
    return this.httpClient.get(url);
  }

  public updateOrder(accession) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/RequisitionIntake/UpdateOrder?accession=${accession}`;
    return this.httpClient.get(url);
  }

  public getExisting(accession) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/RequisitionIntake/GetExisting?accession=${accession}`;
    return this.httpClient.get(url);
  }

  public canAccessionBeUsed(accession) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/RequisitionIntake/CanAccessionBeUsed?accession=${accession}`;
    return this.httpClient.get(url);
  }

  public Save(dto) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/RequisitionIntake/Save`;
    return this.httpClient.post(url, dto);
  }

}
